import { useQuery } from "@apollo/client";
import { withErrorBoundary } from "@sentry/react";
import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import {
  GetArtifactComponentQueryQuery,
  GetArtifactComponentQueryQueryVariables,
} from "types/graphql-schema";

import Artifact from "@apps/artifact/artifact";
import getArtifactComponentQuery from "@apps/artifact/graphql/get-artifact-component-query";
import ErrorFallback from "@components/error-fallback/error-fallback";

const AskAIArtifactComponent = ({ id }: { id: number | null }) => {
  const { ref, inView } = useInView();
  const [hasBeenInView, setHasBeenInView] = useState(false);
  const { data } = useQuery<
    GetArtifactComponentQueryQuery,
    GetArtifactComponentQueryQueryVariables
  >(getArtifactComponentQuery, {
    variables: { artifactId: id || 0 },
    skip: !id || !hasBeenInView,
    fetchPolicy: "cache-first",
  });
  const artifact = data?.artifact;

  useEffect(() => {
    if (inView) setHasBeenInView(true);
  }, [inView]);

  return (
    <div ref={ref}>
      {artifact ? (
        <Artifact artifact={artifact} />
      ) : (
        <div className="flex gap-3">
          <div className="text-gray-500 bg-gray-100 animate-pulse rounded-full h-6 w-6" />
          <div className="text-gray-500 bg-gray-100 animate-pulse rounded-md h-6 flex-1" />
          <div className="text-gray-500 bg-gray-100 animate-pulse rounded-md h-6 w-24" />
        </div>
      )}
    </div>
  );
};

const AskAIArtifactWithSentry = withErrorBoundary(AskAIArtifactComponent, {
  fallback: ErrorFallback,
});

export default AskAIArtifactWithSentry;
